import { connectedLoadWrapper } from './loadWrapper';
import { startUnleash } from '../reducers/unleashReducer';

// TODO: consider using proxy-client-react after nodejs upgrade
export const withReadyUnleash = connectedLoadWrapper({
  isLoadedSelector: (state) => state.unleash.isReady,
  isLoadingSelector: (state) => state.unleash.isReadyPending,
  errorSelector: () => false,
  fetchAction: startUnleash,
});
